import { render, staticRenderFns } from "./MyVipOrderSubscribe.vue?vue&type=template&id=4ef49cd9&scoped=true"
import script from "./MyVipOrderSubscribe.vue?vue&type=script&lang=js"
export * from "./MyVipOrderSubscribe.vue?vue&type=script&lang=js"
import style0 from "./MyVipOrderSubscribe.vue?vue&type=style&index=0&id=4ef49cd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef49cd9",
  null
  
)

export default component.exports